var map = {
	"./arrowDown.svg": 22089,
	"./arrowDownActive.svg": 74815,
	"./arrowUp.svg": 30886,
	"./arrowUpActive.svg": 35516,
	"./avaxApr.svg": 98791,
	"./avaxBg.webp": 34355,
	"./avaxBgMobile.webp": 81297,
	"./bnbApr.svg": 49123,
	"./bscBg.webp": 36489,
	"./bscBgMobile.webp": 2647,
	"./cawsApr.svg": 31611,
	"./cawsBg.webp": 59391,
	"./cawsBgMobile.webp": 7405,
	"./closeX.svg": 41086,
	"./ethApr.svg": 738,
	"./ethBg.webp": 86794,
	"./ethBgMobile.webp": 89872,
	"./hotTag.svg": 10257,
	"./nftTag.svg": 22162,
	"./premiumBg.webp": 4976,
	"./premiumBgMobile.webp": 89230,
	"./searchIcon.svg": 70597,
	"./stakeTag.svg": 78496,
	"./watch.svg": 64115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26984;